import styled from "styled-components"

export const LanguagesButtonWrapper = styled.div`
  position: absolute;
  top: -20px;
  right: -51px;
  display: flex;
  align-items: center;
  z-index: 15;

  @media screen and (max-width: 992px) {
    right: 30px;
    top: -75px;
  }
`

export const LanguageOption = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: black;
  transition: all 0.2s;
  padding: 10px 15px;
  cursor: pointer;

  &:not(:last-child) {
    border-bottom: 1px solid #00000022;
  }

  &:hover {
    color: var(--primary);
  }

  &.active {
    span {
      font-weight: 600;
    }
  }

  span {
    font-size: 13px;
    margin-left: 5px;
    font-weight: 500;
  }

  .flag {
    width: 27px;
    height: 27px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 5px;
    border: none;
    box-sizing: content-box;
    cursor: pointer;
    transition: all 0.4s;

    &:hover {
      transform: scale(1.05);
    }

    &:not(:last-child) {
    }
    div,
    img {
      object-fit: cover;
      width: 102%;
      height: 102%;
    }
    @media screen and (max-width: 992px) {
      width: 29px;
      height: 29px;
    }
  }
`

export const Button = styled.button`
  color: #fff;
  background: none;
  border: none;
  transition: all 0.2s;
  cursor: pointer;

  @media screen and (max-width: 992px) {
    color: var(--primary);
  }

  span {
    position: absolute;
    bottom: 2px;
    right: -0px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    width: 17px;
    height: 17px;
    border-radius: 50%;
    text-transform: uppercase;
    font-weight: 700;
    color: black;
    font-size: 9px;
  }

  &:hover {
    transform: scale(1.1);
  }

  svg.white {
    color: #fff;
    transition: color 0.2s;
  }
`

export const Popup = styled.div`
  position: absolute;
  bottom: -20px;
  left: -70px;
  background-color: #fff;
  border-radius: 10px;
  transform: translateY(100%);
  transition: all 0.2s ease-in;
  box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.1);

  &:after {
    content: "";
    position: absolute;
    top: -5px;
    right: 30px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #fff;
  }

  ${props => `
    opacity: ${props.isVisible ? 1 : 0};
    pointer-events: ${props.isVisible ? "all" : "none"};
  `}
`
